export enum LegListSortingTypeEnum {
  Departure = 1,
  ProfitAndLoss = 2,
  LoadFactor = 3,
}
